import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications

import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
// import { TimeframeSurcharge } from 'src/app/shared/models/timeframeSurcharges.model';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';
import { setCurrencyCode } from '@syncfusion/ej2-base';
import { SubjectsUrgentExportJobShedule } from 'src/app/shared/models/subjectsUrgentExportJobSchedule.model';
import { Brand } from 'src/app/shared/models/brand.model';
import { IFilter, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';

setCurrencyCode('AUD');

@Component({
  selector: 'app-subjects-urgent-export-job-schedule-create',
  templateUrl: './subjects-urgent-export-job-schedule-create.component.html',
  styleUrls: ['./subjects-urgent-export-job-schedule-create.component.scss']
})
export class SubjectsUrgentExportJobScheduleCreateComponent implements OnInit {

    @ViewChild('traceForm') traceForm: any;

    model: any;
    job_types: any;
    job_type_locations: Object;
    count2: any;
    get_latest_court_id: Object;
    job_type_court: Object;

      
    combo_model: Brand;
  
    @Input() intialCount = 221;
    @Input() count = this.intialCount;
    // sees if there is a change in myCount
  @Output()
  change: EventEmitter<number> = new EventEmitter<number>();
    job_type: Object;
    job_type_location: Object;
  
  
    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
    job_service_rules: any;
    subject_service_type: any;
  timeframe_surcharge: any;


  timeUnits: string[] = ['Hours', 'Days', 'Weeks'];
  selectedTimeUnit: string = 'Hours'; // default value
  
  public cValue: string = "#1de4d7";
  get_latest_timeframe_surcharge_id: Object;
  clients: Object;
  brands: any;
  job_status_run: any;
  job_status_data: any;
  sent_brand_id: any;
  brand_users: any;
  brands_client: any;
  brands_agent: any;
  brand_users_data: any;
  brand_report_selected: any;
  selected_brand_data: any;
  timeframe_surcharges: any;
  get_latest_job_schedule_id: Object;
  @Input('value')
  set value(value: any) {
      this.cValue = value;
  }
  search_model_duration_array: any[];
  duration_seconds: number;
duration_minutes: number;
duration_hours: number;


public selectionOptions: SelectionSettingsModel;

public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };

  formatoptions: { type: string; format: string; };
  dateFormat: string;
  public filter : IFilter;

  //matched to emum database row
  // schedule-job.component.ts
frequencyOptions: string[] = [
  'daily', 'weekly', 'fortnight', 'monthly', 'quarterly', 'halfyearly', 'yearly'
];

  constructor(
      private http: HttpClient,
  private _demoService: DemoService,
  private route: ActivatedRoute,
  private router: Router,
  public toastr: HotToastService,
  vcr: ViewContainerRef,
  private modalService: BsModalService, viewRef: ViewContainerRef,
  public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit(): void {
       this.model = new SubjectsUrgentExportJobShedule();
        // this.getJobServiceRules();
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };

   this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'



this.getJobStatusNames() // load the drop down
this.getTimeframeSurcharges();

this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    this.getBrandsComboBoxClients(this.combo_model);
    this.getBrandsComboBoxAgents(this.combo_model);
    this.getJobTypes();

     

  }


  createTimeframeSurcharges(model) {
    // console.log(model);
        this._demoService.createTimeframeSurcharges(model).subscribe(
             data => {  this.get_latest_timeframe_surcharge_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Timeframe Surcharge :: Please try again!');
               console.log(error);
                              // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('New Subjects Urgent Export Schedule Added');
       };
 


  createSubjectsUrgentExportJobSchedule(model) {
    // console.log(model);
    model.suot_id = '6'
        this._demoService.createSubjectsUrgentExportJobSchedule(model).subscribe(
             data => {  this.get_latest_job_schedule_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Subject Urgent Export shedule Failed :: Please try again!');
               console.log(error);
                              // return Observable.throw(error);
             }
        );
        }







    setColour(value2){
      console.log('SetColour: ' + value2)
      this.traceForm.colour.value = this.traceForm.colourpicker.value
    }
    


    getDurationFromMillisenconds(t) {
      let year,
          month,
          day,
          hour,
          minute,
          second;
    
      second = Math.floor(t / 1000);
      minute = Math.floor(second / 60);
      second = second % 60;
      hour = Math.floor(minute / 60);
      minute = minute % 60;
      day = Math.floor(hour / 24);
      hour = hour % 24;
      month = Math.floor(day / 30);
      day = day % 30;
      year = Math.floor(month / 12);
      month = month % 12;
    
      this.search_model_duration_array = []; // empty first
    
      this.search_model_duration_array.push({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        });
        this.search_model_duration_array = this.search_model_duration_array;
    
    
      // return { year, month, day, hour, minute, second };
      return year + 'yrs ' +  month + ' months ' + day + ' days ' + hour + ' hrs ' + minute + ' mins ' + second + ' sec ' ;
    
    
      // rewrite this scipt to return a model and oject so I can choose to dispaly or not and make a better UI system with the data
    
    
    
    }




    
    // Get Date Duration Between Two Dates
    getDateTimeDuration(a,b){
    // const firstDate: Date = new Date('2023-12-21');
    // // Current Date
    // const secondDate: Date = new Date();
    
    
    this.model.Duration = 0;// set to null
    
    
    const firstDate: Date = b;
    const secondDate: Date = a;
    
    
    // Time Difference in Milliseconds
    const milliDiff: number = firstDate.getTime()
        - secondDate.getTime();
    
    // Converting time into hh:mm:ss format
    
    // Total number of seconds in the difference
    const totalSeconds = Math.floor(milliDiff / 1000);
    
    // Total number of minutes in the difference
    const totalMinutes = Math.floor(totalSeconds / 60);
    
    // Total number of hours in the difference
    const totalHours = Math.floor(totalMinutes / 60);
    
    // Getting the number of seconds left in one minute
    const remSeconds = totalSeconds % 60;
    
    // Getting the number of minutes left in one hour
    const remMinutes = totalMinutes % 60;
    
    console.log(`${totalHours}:${remMinutes}:${remSeconds}`);
    
    this.duration_seconds = totalSeconds;
    this.duration_minutes = totalMinutes;
    this.duration_hours = totalHours;
    
    // now run the function to build the duration model
    this.toastr.info('Re calculating Item Duration')
    
    // set back the main variables
    // this.model.Duration = milliDiff;
    // this.model.StartTime = a;
    // this.model.EndTime = b;
    
    this.model.Duration = milliDiff;
    this.model.when_from = a
    this.model.when_to = b
    
    
    return milliDiff; // returns the difference in milliseconds.
    }
    
    
    getTimeFromNow(a, b){
    
    const firstDate: Date = b;
    const secondDate: Date = a;
    
    return moment(b, 'YYYYMMDD').fromNow()
    
    }



    onModelChange(model: any): void {
      if (!model.timeframe_from || !model.timeframe_to) {
        model.timeframe_duration_ms = 0;
        return;
      }
    
      const from = new Date(model.timeframe_from);
      const to = new Date(model.timeframe_to);
      const diffMs = Math.abs(to.getTime() - from.getTime());
    
      // Always store ms as base
      model.timeframe_duration_ms = diffMs;

      this.model.timeframe_duration_ms = diffMs;
    
      // Optional: convert to readable breakdown
      this.getDurationFromMillisenconds(diffMs);
    }







getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

// need to get new clients
getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => {
        this.job_status_run = res
        this.job_status_data = res
      },
      err => console.error(err.status)
    );
}




getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getBrandsComboBoxAgents(combo_model) {
  this.combo_model.brand_type_id = 3;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_agent = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



 // drop down action
 sendBrandID(brand_report_id) {
  this.sent_brand_id = brand_report_id;
 
  // reset the form field first.
  // this.model.brand_report_user_id = '';
  // this.brand_users = '';
      // empty the array incase there are no users to prevent prev selection
      this.brand_users = null;
 
  if(brand_report_id >= 1) {
 // this.getBrandUsers(brand_report_id); // updates the selected brand_ ID....
 this._demoService.getBrandUsersByLevel(brand_report_id, 9).subscribe(
   data => { this.brand_users = data;
 
 
     this.brand_users_data = data;
 
 
     let res = data[0];
  },
   err =>  console.error(err),
   // () => console.log('done loading Trace Types')
 );


 // this.model.brand_report_id = brand_report_id;
// need to look up what brands notes are and send to jon notes.
 // console.log('sending Brand ID:' + this.sent_brand_id);
// lookup brand
// set this.model.special_instuctions.
this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function
 }


}
 
getBrandById_instructions(brand_id){
  this._demoService.getBrandById(brand_id)
  .subscribe(
    res => {this.brand_report_selected = res;
      this.selected_brand_data = res[0];

    //  this.new_special_instuctions = this.selected_brand_data.brand_notes;
    //  this.model.special_instructions = this.new_special_instuctions;
    //  this.model.special_instructions_HTML = this.new_special_instuctions;

     // console.log('instuctions: ' + this.new_special_instuctions);
   
    },
    err => console.error(err.status)
  );
 }

//  private getJobStatusNames() {
//   this._demoService.getJobStatusNames()
//     .subscribe(
//       res => this.job_status = res,
//       err => console.error(err.status)
//     );
// }

getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }



}
